module.exports = __WEBPACK_EXTERNAL_MODULE_108__;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 108
// module chunks = 0